import { Route, Routes } from "react-router-dom";

import { UploadVisualAreaContent } from "@rapid/components/flow/build/Steps/Upload/VisualAreaContent";
import { GuardedRoute } from "@rapid/components/routing/GuardedRoute";
import { useGuardUpload } from "@rapid/hooks/guards/useGuardUpload";

export const SetupRoutes = () => {
    return (
        <Routes>
            <Route
                index
                element={
                    <GuardedRoute useGuardStep={useGuardUpload}>
                        <UploadVisualAreaContent />
                    </GuardedRoute>
                }
            />
        </Routes>
    );
};
